import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ConfigurationAssayLaboratoryCreateRequest, ConfigurationAssayLaboratoryPatchInBatchRequest, ConfigurationAssayLaboratoryResponse } from '@/modules/configurationModule/detail/local-assays/assays-laboratory/services/configuration-assay-laboratory/configuration-assay-laboratory.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationAssayLaboratoryService {
    async create(laboratoryId: number, request: ConfigurationAssayLaboratoryCreateRequest): Promise<ConfigurationAssayLaboratoryResponse> {
        const response = await axios.post<ConfigurationAssayLaboratoryResponse>(`/configuration/laboratories/${laboratoryId}/assayLaboratories`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationAssayLaboratoryResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationAssayLaboratoryResponse>>(`/configuration/laboratories/${laboratoryId}/assayLaboratories`, { ...filterModel }, { params })
        return response.data
    }

    async get(assaygroupLaboratoryId: number, laboratoryId: number): Promise<ConfigurationAssayLaboratoryResponse> {
        const response = await axios.get<ConfigurationAssayLaboratoryResponse>(`/configuration/laboratories/${laboratoryId}/assayLaboratories/${assaygroupLaboratoryId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/assayLaboratories/batch`, { data: request })
        return response.data
    }

    async patch(laboratoryId: number, request: ConfigurationAssayLaboratoryPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/assayLaboratories/batch`, request)
        return response.data
    }
}

export const configurationAssayLaboratoryService = new ConfigurationAssayLaboratoryService()
